import React, { Component } from 'react';
import { PanelGroup, Modal } from 'react-bootstrap'
import { connect } from 'react-redux'
import { addList, editList } from 'actions/bookmakerLists'
import { changeUser } from 'actions/auth'
import { tokenize } from 'utils/helpers'
import braintree from 'braintree-web'
import BookmakerListComponent from './BookmakerListComponent'
import { bookmakers } from 'config'
import { restUrl } from 'config'
import request from 'superagent'

class Bookmakers extends Component {
  constructor(props) {
    super(props)
  }

  addList() {
    const { dispatch } = this.props
    dispatch(addList())
  }

  render() {
    if (Object.keys(this.props.bookmakerLists).length === 0) {
      return <button className="btn btn-success" onClick={this.addList.bind(this)}>Add bookmakers</button>
    }
    if (this.props.user.permissionLevel === 1) {
      return <HobbyBookmakers bookmakerLists={this.props.bookmakerLists} dispatch={this.props.dispatch} user={this.props.user}/>
    }
    return (
      <div>

        <PanelGroup className='panelGroup'>
          { Object.keys(this.props.bookmakerLists).map(key => {
            let list = this.props.bookmakerLists[key]
            return (
              <BookmakerListComponent
                dispatch={ this.props.dispatch }
                key={key}
                listId={key}
                user={this.props.user}
                { ...list }
              />
            )
          })}
        </PanelGroup>
        <button id='addListButton' className='btn btn-success pull-left' onClick={this.addList.bind(this)}> Add a new list</button>
      </div>
    )
  }
}

class HobbyBookmakers extends Component {
  constructor(props) {
    super(props)
    this.bookmakerList = Object.assign({}, this.props.bookmakerLists[Object.keys(this.props.bookmakerLists)[0]], {
      id: Object.keys(this.props.bookmakerLists)[0]
    })
    this.state = {
      editing: false,
      bookmakers: this.bookmakerList.bookmakers,
      showBuyModal: false
    }
  }

  changeBookmakers() {
    if (!this.state.editing) {
      this.setState({
        editing: true
      })
    } else {
      if (JSON.stringify(Object.keys(this.bookmakerList.bookmakers)) === JSON.stringify(Object.keys(this.state.bookmakers))) {
        // No changes were made
        this.setState({
          editing: false,
          areYouSureModal: false
        })
        return
      }
      window.analytics.track('Changed bookmakers')
      const { dispatch } = this.props
      dispatch(editList(this.bookmakerList.id, {
        bookmakers: this.state.bookmakers
      }))
      dispatch(changeUser(this.props.user.id, {
        bookmakerChanges: this.props.user.bookmakerChanges - 1
      }))
      this.setState({
        editing: false,
        areYouSureModal: false
      })
    }
  }

  toggleBookmaker(key) {
    let bookmakers = Object.assign({}, this.state.bookmakers)
    if (bookmakers[key])
      delete bookmakers[key]
    else {
      if (Object.keys(bookmakers).length < 3)
        bookmakers[key] = true
    }
    this.setState({bookmakers})
  }

  openModal() {
    this.setState({
      showBuyModal: true
    })
  }

  areYouSure() {
    this.setState({
      areYouSureModal: true
    })
  }

  render() {
    let selectedBookmakers = Object.keys(this.state.bookmakers).map(key => {
      return <div key={key} className='bookmaker selected'>{ bookmakers[+key] }</div>
    })
    if (this.state.editing) {
      selectedBookmakers = Object.keys(bookmakers).map(key => {
        return (
          <div onClick={this.toggleBookmaker.bind(this, +key)}
            key={key} className={'bookmaker' + (this.state.bookmakers[+key] ? ' selected' : '')}>{ bookmakers[+key]}
          </div>
        )
      })
    }
    let buttonClassname = 'btn btn-success'
    let buttonText = 'Change bookmakers'
    let onClick = this.changeBookmakers.bind(this)
    let pluralizedChanges = '1 change'
    let mutedText = 'You can only change your bookmakers once a month on the hobby plan. If you want to change them again, you can switch for a one-time-fee of £10.'
    if (this.props.user.bookmakerChanges <= 0) {
      buttonText = 'Unlock new bookmakers (£10)'
      onClick = this.openModal.bind(this)
      mutedText = 'You have used up your one switch per month. If you want to change your bookmakers again - you can buy a reroll for £10 or wait until next month :-)'
      pluralizedChanges = 'no changes'
    } else if (this.props.user.bookmakerChanges > 1) {
      pluralizedChanges = this.props.user.bookmakerChanges + ' changes'
    }
    if (this.state.editing) {
      buttonText = 'Save changes'
      onClick = this.areYouSure.bind(this)
    }
    let nSelected = Object.keys(this.state.bookmakers).length
    return (
      <div>
        <div className='selected-bookmakers'>
          <h5>These are your current bookmakers ({ nSelected } / 3)</h5>
          { selectedBookmakers }
        </div>
        <hr />
        <div className='row'>
          <h5>You have { pluralizedChanges } left this month</h5>
          <p>{ mutedText }</p>
          <button className={buttonClassname} onClick={onClick}>{ buttonText }</button>
        </div>
        <BuyBookmakerChangeModal show={this.state.showBuyModal} onHide={() => this.setState({showBuyModal: false})} />
        <AreYouSureModal show={this.state.areYouSureModal}
          onHide={() => this.setState({areYouSureModal: false})}
          onSuccess={this.changeBookmakers.bind(this)} />
      </div>
    )
  }
}

class BuyBookmakerChangeModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      waitingForToken: true,
      success: false,
      error: null
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.show === false && this.props.show === true) {
      this.requestClientToken()
    }
  }

  requestClientToken() {
    tokenize(request.get(restUrl + 'braintree/clientToken'))
      .then(result => {
        braintree.setup(result.clientToken, 'dropin', {
          container: 'dropin-container',
          onPaymentMethodReceived: this.onPaymentMethodReceived.bind(this),
          onError: () => this.setState({loading: false, error: result.message}),
          onReady: () => this.setState({waitingForToken: false})
        })
      })
  }

  onHide() {
    this.setState({
      loading: false,
      error: null,
      success: false,
      waitingForToken: true
    })
    this.props.onHide()
  }

  onPaymentMethodReceived(obj) {
    const { nonce } = obj
    tokenize(request.post(restUrl + 'braintree/buybookmakerchange').send({paymentMethodNonce: nonce}))
      .then(() => {
        window.analytics.track('Bought bookmaker change')
        this.setState({
          loading: false,
          success: true
        })
      }).catch(error => {
        this.setState({
          error,
          loading: false
        })
      })
  }

  onSubmit(e) {
    this.setState({
      loading: true,
      error: null
    })
    e.preventDefault()
  }

  render() {
    if (this.state.success) {
      return (
        <Modal show={this.props.show} onHide={this.onHide.bind(this)}>

          <Modal.Body>
            <div className='col-xs-12 bookmaker-buy-success'>
              <div className='text-center'>
                <i className='ionicons ion-ios-checkmark-outline'></i>
                <p className='lead'>Excellent. Now you can place bets on new bookies!</p>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button onClick={this.onHide.bind(this)} className='btn btn-success'>Close</button>
          </Modal.Footer>
        </Modal>
      )
    }
    let alert = (
      <div className='alert alert-danger'>
        <button type='button' className='close' onClick={() => this.setState({error: null})}>×</button>
        <span>{ this.state.error }</span>
      </div>
    )
    return (
      <Modal show={this.props.show} onHide={this.onHide.bind(this)}>
        <Modal.Header closeButton>
          <Modal.Title>Buy a bookmaker change</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          { this.state.error && alert }
          <form className='form' onSubmit={this.onSubmit.bind(this)}>
            <div id='dropin-container' />
            { (this.state.loading || this.state.waitingForToken) ? <button className='btn btn-success' disabled><i className='fa fa-spin fa-spinner'></i></button> : <button type='submit' className='btn btn-success'>Buy new bookmakers (£10)</button> }
          </form>
        </Modal.Body>
      </Modal>
    )
  }
}

class AreYouSureModal extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <Modal show={this.props.show} onHide={this.props.onHide}>
        <Modal.Header closeButton>
          <Modal.Title>Are you sure?</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className='lead'>Are you sure you want these to be your bookmakers? You can only change once per month!</p>
        </Modal.Body>
        <Modal.Footer>
          <button className='btn btn-success' onClick={this.props.onSuccess} >Yes</button>
          <button className='btn btn-danger' onClick={this.props.onHide}>No</button>
        </Modal.Footer>
      </Modal>
    )
  }
}

export default connect(state => {
  return {
    bookmakerLists: state.bookmakerLists
  }
})(Bookmakers)



/** WEBPACK FOOTER **
 ** ./src/components/profile/BookmakersTab.js
 **/